import React from "react";
import { Logo } from "./Logo";
import BookChatCTA from "./BookChatCTA";
import { useContent } from "../../content/ContentContext";

export const Hero = ({ calendlyUrl }) => {
  const c = useContent("hero");
  return (
    <section id="top" data-testid="hero-section" className="relative pt-32 md:pt-40 pb-20 md:pb-28 overflow-hidden">
      <div aria-hidden="true" className="absolute inset-0 pointer-events-none">
        <div className="absolute left-1/2 top-12 -translate-x-1/2 w-[680px] h-[680px] sc-watercolor opacity-60" />
        <div
          className="absolute right-[-120px] top-[-80px] w-[420px] h-[420px] rounded-full blur-3xl opacity-40"
          style={{ background: "radial-gradient(circle, rgba(201,169,97,0.18), transparent 60%)" }}
        />
      </div>

      <div className="sc-container relative">
        <div className="flex justify-center mb-10 md:mb-12 animate-fade-up">
          <Logo size="lg" />
        </div>

        <div className="flex justify-center mb-6 animate-fade-up" style={{ animationDelay: "120ms" }}>
          <span className="sc-eyebrow">{c.eyebrow}</span>
        </div>

        <h1 className="sc-h1 text-center max-w-4xl mx-auto animate-fade-up" style={{ animationDelay: "220ms" }} data-testid="hero-headline">
          {c.headline_pre}{" "}
          <em className="not-italic text-magenta">{c.headline_em}</em>{" "}
          {c.headline_post}
        </h1>

        <div className="mt-8 max-w-2xl mx-auto text-center animate-fade-up" style={{ animationDelay: "320ms" }}>
          <p className="sc-lede">{c.paragraph1}</p>
          <p className="sc-lede mt-4">{c.paragraph2}</p>
        </div>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-x-6 gap-y-5 animate-fade-up" style={{ animationDelay: "420ms" }}>
          <BookChatCTA calendlyUrl={calendlyUrl} label={c.primary_cta} testId="hero-book-chat-btn" />
          <a href="#about" className="sc-link text-sm font-body" data-testid="hero-learn-more-link">
            {c.secondary_link}
          </a>
        </div>
      </div>
    </section>
  );
};

export default Hero;
